// extracted by mini-css-extract-plugin
export default {"container":"LoadingMailing_container__oqt+R"};